import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { Icons } from '../../../components';
import LocaleMenuModal from '../../../components/LocaleMenu/LocaleMenu';
import { persistLocale } from '../../../util/genericHelpers';

export const normalizeLocale = locale => ((locale || 'en').toLowerCase() === 'th' ? 'th' : 'en');

export const readLocaleFromLocalStorage = () => {
  try {
    if (typeof window === 'undefined') return null;
    const locale = window.localStorage.getItem('locale');
    return locale ? normalizeLocale(locale) : null;
  } catch (e) {
    return null;
  }
};

export const writeLocaleToLocalStorage = nextLocale => {
  return persistLocale(nextLocale);
};

const GuestLanguageSelector = props => {
  const {
    intl,
    onManageDisableScrolling,
    buttonClassName,
    dataTestId = 'guest-language-menu-trigger',
  } = props;
  const [isLocaleOpen, setIsLocaleOpen] = useState(false);
  const [currentLocale, setCurrentLocale] = useState('en');

  useEffect(() => {
    const stored = readLocaleFromLocalStorage();
    if (stored) setCurrentLocale(stored);
  }, []);

  const title = intl.formatMessage({
    id: 'TopbarDesktop.selectLanguage',
    defaultMessage: 'Select Language',
  });

  const handleSelectLocale = nextLocale => {
    try {
      const normalized = normalizeLocale(nextLocale);
      writeLocaleToLocalStorage(normalized);
      setCurrentLocale(normalized);
      setIsLocaleOpen(false);
    } catch (e) {
      console.error('Failed to change locale', e);
      setIsLocaleOpen(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className={classNames(buttonClassName)}
        onClick={() => setIsLocaleOpen(true)}
        title={title}
        aria-label={title}
        data-testid={dataTestId}
      >
        <Icons name="globe" />
      </button>

      <LocaleMenuModal
        isOpen={isLocaleOpen}
        onClose={() => setIsLocaleOpen(false)}
        currentLocale={currentLocale}
        onSelectLocale={handleSelectLocale}
        title={title}
        onManageDisableScrolling={onManageDisableScrolling}
      />
    </>
  );
};

export default GuestLanguageSelector;
